export default __webpack_public_path__ + "static/media/cntr-tracking-rq-light.07912c7c.svg";